import { createAction, props } from '@ngrx/store';
import {
  AccidentBenefit,
  BasicOfferType,
  BenefitDuration,
  CapitalOfDailyCash,
  CapitalOfHospitalCapital,
  CapitalOfHospitalDailyCash,
  CostSharing,
  DeathBenefit,
  DentalLevel,
  DisabilityBenefit,
  HospitalOfferType,
  HospitalVivaOfferType,
  Level,
  Region,
  WaitingPeriodDailyCash,
  WaitingPeriodHospitalDailyCash,
} from '../../../api';

export const selectOutpatientProduct = createAction(
  '[Offer] Select outpatient product for person',
  props<{
    personId: number;
    level: Level;
  }>(),
);

export const deselectOutpatientProduct = createAction(
  '[Offer] Deselect outpatient product for person',
  props<{
    personId: number;
  }>(),
);

export const selectOutpatientVivaProduct = createAction(
  '[Offer] Select outpatient viva product for person',
  props<{
    personId: number;
    level: Level;
  }>(),
);

export const deselectOutpatientVivaProduct = createAction(
  '[Offer] Deselect outpatient viva product for person',
  props<{
    personId: number;
  }>(),
);

export const selectComplementaryProduct = createAction(
  '[Offer] Select complementary product for person',
  props<{
    personId: number;
    level: Level;
  }>(),
);

export const deselectComplementaryProduct = createAction(
  '[Offer] Deselect complementary product for person',
  props<{
    personId: number;
  }>(),
);

export const selectComplementaryVivaProduct = createAction(
  '[Offer] Select complementary viva product for person',
  props<{
    personId: number;
    level: Level;
  }>(),
);

export const deselectComplementaryVivaProduct = createAction(
  '[Offer] Deselect viva complementary viva product for person',
  props<{
    personId: number;
  }>(),
);

export const selectBasicProduct = createAction(
  '[Offer] Select basic product for person',
  props<{
    personId: number;
    offerType: BasicOfferType;
    costSharing?: CostSharing;
    region?: Region;
  }>(),
);

export const deselectBasicProduct = createAction(
  '[Offer] Deselect basic product for person',
  props<{
    personId: number;
  }>(),
);

export const selectHospitalProduct = createAction(
  '[Offer] Select hospital product for person',
  props<{
    personId: number;
    offerType: HospitalOfferType;
    costSharing?: CostSharing;
    region?: Region;
  }>(),
);

export const deselectHospitalProduct = createAction(
  '[Offer] Deselect hospital product for person',
  props<{
    personId: number;
  }>(),
);

export const selectHospitalVivaProduct = createAction(
  '[Offer] Select hospital VIVA product for person',
  props<{
    personId: number;
    offerType: HospitalVivaOfferType;
    costSharing?: CostSharing;
    region?: Region;
  }>(),
);

export const deselectHospitalVivaProduct = createAction(
  '[Offer] Deselect hospital VIVA product for person',
  props<{
    personId: number;
  }>(),
);

export const selectHospitalCapitalProduct = createAction(
  '[Offer] Select hospital capital product for person',
  props<{
    personId: number;
    capital: CapitalOfHospitalCapital;
    accidentCoverage: boolean;
  }>(),
);

export const deselectHospitalCapitalProduct = createAction(
  '[Offer] Deselect hospital capital product for person',
  props<{
    personId: number;
  }>(),
);

export const selectAccidentDeathCapitalProduct = createAction(
  '[Offer] Select death and accident capital product for person',
  props<{
    personId: number;
    accidentBenefit: AccidentBenefit;
  }>(),
);

export const deselectAccidentDeathCapitalProduct = createAction(
  '[Offer] Deselect death and accident capital product for person',
  props<{
    personId: number;
  }>(),
);

export const selectAccidentDisabilityCapitalProduct = createAction(
  '[Offer] Select accident disability capital product for person',
  props<{
    personId: number;
    accidentBenefit: AccidentBenefit;
  }>(),
);

export const deselectAccidentDisabilityCapitalProduct = createAction(
  '[Offer] Deselect accident disability capital product for person',
  props<{
    personId: number;
  }>(),
);

export const selectSicknessDeathOrDisabilityCapitalProduct = createAction(
  '[Offer] Select sickness (death or disability) capital product for person',
  props<{
    personId: number;
    deathBenefit: DeathBenefit;
    disabilityBenefit: DisabilityBenefit;
  }>(),
);

export const deselectSicknessDeathOrDisabilityCapitalProduct = createAction(
  '[Offer] Deselect sickness (death or disability) capital product for person',
  props<{
    personId: number;
  }>(),
);

export const selectLegalProtectionProduct = createAction(
  '[Offer] Select legal protection product for person',
  props<{
    personId: number;
  }>(),
);

export const deselectLegalProtectionProduct = createAction(
  '[Offer] Deselect legal protection product for person',
  props<{
    personId: number;
  }>(),
);

export const selectDentalProduct = createAction(
  '[Offer] Select dental product for person',
  props<{
    personId: number;
    level: DentalLevel;
  }>(),
);

export const deselectDentalProduct = createAction(
  '[Offer] Deselect dental product for person',
  props<{
    personId: number;
  }>(),
);

export const selectHospitalDailyCashProduct = createAction(
  '[Offer] Select hospital daily cash product for person',
  props<{
    personId: number;
    benefitDuration: BenefitDuration;
    capital: CapitalOfHospitalDailyCash;
    waitingPeriod: WaitingPeriodHospitalDailyCash;
  }>(),
);

export const deselectHospitalDailyCashProduct = createAction(
  '[Offer] Deselect hospital daily cash product for person',
  props<{
    personId: number;
  }>(),
);

export const selectDailyCashProduct = createAction(
  '[Offer] Select daily cash product for person',
  props<{
    personId: number;
    accidentCoverage: boolean;
    capital: CapitalOfDailyCash;
    waitingPeriod: WaitingPeriodDailyCash;
  }>(),
);

export const deselectDailyCashProduct = createAction(
  '[Offer] Deselect daily cash product for person',
  props<{
    personId: number;
  }>(),
);

export const selectEmergencyCareProduct = createAction(
  '[Offer] Select emergency care product for person',
  props<{
    personId: number;
  }>(),
);
export const deselectEmergencyCareProduct = createAction(
  '[Offer] Deselect emergency care product for person',
  props<{
    personId: number;
  }>(),
);

export const selectAccidentMedicalExpensesSupplementProduct = createAction(
  '[Offer] Select accident medical expenses supplement product for person',
  props<{
    personId: number;
  }>(),
);
export const deselectAccidentMedicalExpensesSupplementProduct = createAction(
  '[Offer] Deselect accident medical expenses supplement product for person',
  props<{
    personId: number;
  }>(),
);
